import { RootState, SetState } from '@/store/useStore.ts';
import {
  RecentlyPlayedContext,
  RecentlyPlayedSlice,
  RecentlyPlayedStatus,
  RecentlyPlayedStoreParts,
} from '@/store/slices/recentlyPlayed/types';
import { emptySliceError } from '../sliceError';

const defaultRecentlyPlayedContext: RecentlyPlayedContext = {
  recentlyPlayed: null,
  nextGameId: null,
  nextGameUid: null,
  nextGameUrl: null,
};

const defaultRecentlyPlayedStatus: RecentlyPlayedStatus = {
  loading: false,
};

const defaults = {
  [RecentlyPlayedStoreParts.recentlyPlayedContext]:
    defaultRecentlyPlayedContext,
  [RecentlyPlayedStoreParts.recentlyPlayedStatus]: defaultRecentlyPlayedStatus,
  [RecentlyPlayedStoreParts.recentlyPlayedError]: emptySliceError(),
} as const;

export const recentlyPlayedSlice = ({
  set,
}: SetState<RootState>): RecentlyPlayedSlice => ({
  recentlyPlayedContext: {
    ...defaults[RecentlyPlayedStoreParts.recentlyPlayedContext],
  },
  recentlyPlayedStatus: {
    ...defaults[RecentlyPlayedStoreParts.recentlyPlayedStatus],
  },
  recentlyPlayedError: {
    ...defaults[RecentlyPlayedStoreParts.recentlyPlayedError],
  },

  setRecentlyPlayedContext: (newState) =>
    set(
      (state: RootState) => ({
        ...state,
        recentlyPlayedContext: {
          ...state.recentlyPlayedContext,
          ...newState,
        },
      }),
      false,
      'recentlyPlayed/setRecentlyPlayedContext',
    ),

  setRecentlyPlayedStatus: (newState) =>
    set(
      (state: RootState) => ({
        ...state,
        recentlyPlayedStatus: {
          ...state.recentlyPlayedStatus,
          ...newState,
        },
      }),
      false,
      'recentlyPlayed/setRecentlyPlayedStatus',
    ),

  setRecentlyPlayedError: (newState) =>
    set(
      (state: RootState) => ({
        ...state,
        recentlyPlayedError: {
          ...state.recentlyPlayedError,
          ...newState,
        },
      }),
      false,
      'recentlyPlayed/setRecentlyPlayedError',
    ),

  resetRecentlyPlayedPart: (part: RecentlyPlayedStoreParts) =>
    set(
      (state) => ({
        ...state,
        [part]: {
          ...defaults[part],
        },
      }),
      false,
      `recentlyPlayed/reset/${part}`,
    ),

  resetAllRecentlyPlayedParts: () =>
    set(
      () => ({
        recentlyPlayedContext: {
          ...defaults[RecentlyPlayedStoreParts.recentlyPlayedContext],
        },
        recentlyPlayedStatus: {
          ...defaults[RecentlyPlayedStoreParts.recentlyPlayedStatus],
        },
        recentlyPlayedError: {
          ...defaults[RecentlyPlayedStoreParts.recentlyPlayedError],
        },
      }),
      false,
      'recentlyPlayed/resetAll',
    ),
});

export type { RecentlyPlayedItem, RecentlyPlayedSlice } from './types';
export { RecentlyPlayedStoreParts } from './types';
